/**
 * 🔴 El contrato lo fijó Elena en su rama (chirigota#486). Se respeta tal cual, nombres
 * incluidos: `birthdate` en minúscula, no `birthDate`.
 */
export interface RequestAccessRecoveryPayload {
	nif: string;
	/** En formato ISO (`YYYY-MM-DD`), que es lo que devuelve un `<input type="date">`. */
	birthdate: string;
	/** Dirección a la que soporte va a contestar. */
	contactEmail: string;
	/** Opcional: otra vía para que soporte pueda verificar a la persona. */
	phone?: string;
}

export interface AccessRecoveryResponse {
	/**
	 * El del envoltorio de comparsa, y es el que vale. `AllExceptionFilter` devuelve
	 * HTTP 200 hasta para un error de validación, así que el código de estado no
	 * distingue; este `success` sí.
	 */
	success: boolean;
	/**
	 * En éxito, `{ success: true }` — siempre lo mismo, exista o no esa persona: sin
	 * contraseña que acertar, el formulario sería un oráculo más cómodo de barrer que el
	 * propio login. En error, el detalle de lo que falló.
	 */
	data?: unknown;
	message?: string;
}

/**
 * «Verifica tu identidad»: el último recurso de quien no puede entrar.
 *
 * Detrás no hay nada automático. Llega a la bandeja de soporte y lo resuelve una
 * persona, así que la pantalla no puede prometer un enlace ni un plazo.
 */
const requestAccessRecovery = async (
	payload: RequestAccessRecoveryPayload
): Promise<AccessRecoveryResponse> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/auth/access-recovery`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(payload)
	});

	return response.json();
};

export default requestAccessRecovery;
